<base-support-modal
	[title]="title"
	[btnOkClass]="'btn-danger'"
	[btnOkLabel]="'Отменить'"
	(onOk)="ok()"
>
	<p>
		У сайта {{ domainUrl }} будут отменнены подписки
	</p>
	
	<ul>
		<li *ngFor="let recurrentProfile of recurrentProfiles">
			{{ recurrentProfile }}
		</li>
	</ul>
</base-support-modal>
